'use strict';

angular.module('amexReconciliationApp').filter('fullName',
  function fullName() {
    return function (user) {
      return user ? user.firstName + ' ' + user.lastName : '';
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/fullName.js
// module id = 556
// module chunks = 0